<template>
    <article class="noticia-el">
        <img class="contenedor-imagen" :src="data.header_img.url"/>
        <div class="contenedor-texto">
            <h2 class="titulo">{{  data.title  }}</h2>
            <p>{{  data.header  }}</p>
            <h3 class="fecha">{{  fecha  }}</h3>
        </div>
        <router-link :to="{  name: 'noticia', params:  {  slug: data.slug  }  }" class="enlace-cover"></router-link>
    </article>
</template>

<script>
export default {
    name: 'noticia-el',
    props: ['data'],
    computed: {
        fecha() {
            return this.dayjs(this.data.publish_date).format('DD MMMM YYYY');
        },
    },
}
</script>